import React from "react";

const Badge = (props) => {

    return(
        <>
           <span
               className={props.badge}> {props.status}
           </span>
        </>
    )
}

export default Badge;